import axios from "axios"

export const getProductImagesService = (productId: string) => {
    return axios.get("Images/products/" + productId);
}

export const getImagesByIds = (imagesIds: string[]) => {
    return axios.get("Images/imagesByIds", { params: { imagesIds } });
}
